module.exports = __webpack_public_path__ + "img/38c634ce7df16e43a769bd7e120598c1.png";